<template>
  <el-dialog :title="`${title}（ID：${formInline.bookId}）`" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="tableSureBtn">
    <div class="top-search">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
          <el-form-item label="日期：">
						<el-date-picker
							v-model="dataTime"
							class="pickerData"
							format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="daterange"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="loss-title">
        <span>流失表详情(投放链接ID:{{tfid?tfid:'所有'}})</span>
        <div @click="lossChange(lossTabVal)">切换<i class="el-icon-refresh"></i></div>
      </div>
      <div class="tableTh" v-if="lossTabVal">
        <el-table :data="tableData.result" border stripe style="width: 100%" max-height="456" class="tableStyle" v-loading="loading">
					<el-table-column prop="chapterNum" label="章节信息">
            <template slot-scope="scope">
              <div class="td-info">
                <p>第{{ scope.row.chapterNum }}章</p>
              </div>
            </template>
          </el-table-column>
					<el-table-column prop="ipv" label="观看人数" ></el-table-column>
					<el-table-column prop="churnRate" label="距上一集流失率">
            <template slot-scope="scope">
              <div class="td-info">
                <p>{{ scope.row.churnRate }}</p>
              </div>
            </template>
          </el-table-column>
					<!-- <el-table-column prop="adPlayNumber" label="解锁类型" >
            <template slot-scope="scope">
              <div class="td-info">
                <p>金币解锁数：{{ scope.row.goldCoinNumber }}</p>
                <p>广告解锁数：{{ scope.row.adNumber }}</p>
                <p>单剧购买数：{{ scope.row.payNumber }}</p>
              </div>
            </template>
          </el-table-column> -->
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination
							@current-change="handleCurrentChange"
							@size-change="handleSizeChange"
							:page-sizes="[5, 10, 20, 50, 100]"
							:page-size="tableData.pageSize"
							background
							:current-page="currentPage"
							layout="sizes, prev, pager, next, jumper, ->, total"
							:total="tableData.totalNum">
					</el-pagination>
				</div>
      </div>
      <!-- 曲线图 -->
			<div v-if="!lossTabVal" id="lineChart" class="lineChart" style="width: 100%; height: 400px;"></div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="tableSureBtn">确 定</el-button>
      </div>
  </el-dialog>
</template>
<script>
// import { analyse } from "@/api/dysvzk/data/videodaily";
import * as echarts from 'echarts';
var lineChart = null;
export default {
  name: 'LossTable',
  props: {
      visible: {
        type: Boolean,
        required: true
      },
      BookInfo:{
        type: Object,
      },
      tfid:{
        type: String,
      },
      Time:{
        type:Array
      }
  },
  data() {
      return {
        innerVisible: this.visible,
        title:'',
        dataTime:[],
        loading: false,
        formInline: {
          bookId: '',
          statStartDate: '',
          statEndDate: '',
        },
        currentPage: 1,
        tableData: {
          pageSize: 10,
          pageNo: 1,
          totalPage: 1,
          totalNum: 0,
          result: [
          ]
        },
        lossTabVal:true,
        QxList:[],
      }
  },
  watch: {
      visible(newValue) {
        this.innerVisible = newValue;
        this.currentPage = 1;
        this.$nextTick(()=>{
          console.log("BookInfo",this.BookInfo)
          this.title = this.BookInfo.bookName
          this.formInline.bookId = this.BookInfo.bookId
          this.dataTime = this.Time;
          this.formInline.statStartDate = this.dataTime ? this.dataTime[0] : ''
          this.formInline.statEndDate = this.dataTime ? this.dataTime[1] : ''
          console.log(" this.formInline", this.formInline)
          this.getTableData()
        })
      },
  },
  mounted() {
    
  },
  methods: {
      // 确定按钮
      tableSureBtn() {
        this.$refs['formInline'].resetFields()
        if(lineChart){
          lineChart.dispose();
        }
        this.lossTabVal = true
        // this.dataTime = this.Time
        this.$emit('cancelDialogApp', false);
      },
      search () {
        this.currentPage = 1
        console.log("ffff",this.lossTabVal)
        if(!this.lossTabVal){
          this.initLineChart()
        }else{
          this.getTableData()
        }
      },
      resetQuery: function(){
        this.$refs['formInline'].resetFields()
        // this.dataTime = this.Time
        this.getTableData()
      },
      handleCurrentChange(value) {
        this.currentPage = value
        this.getTableData()
      },
      handleSizeChange (val) {
        this.tableData.pageSize  = val
        this.currentPage = 1
        this.getTableData()
      },

      //获取详情列表
      getTableData() {
        let json2 = {
          pageNo: this.currentPage,
          pageSize: this.tableData.pageSize
        };
        this.formInline.statStartDate = this.dataTime ? this.dataTime[0] : ''
        this.formInline.statEndDate = this.dataTime ? this.dataTime[1] : ''
        let json1 = this.formInline;
        let paramJson = { ...json1, ...json2 };
        console.log("获取详情列表paramJson",paramJson)
        this.axios({
          method:'get',
          url:'/novel/data/daily/chapterList',
          params:paramJson
        }).then((response)=>{
        if (response.data.head.flag === 0) {
            this.tableData = response.data.content
            this.loading = false
          } else {
            this.$message.error(response.data.head.desc)
          }
        })
      },

      // 切换流失表详情
      lossChange(val){
        this.lossTabVal = !val
        if(val){
          this.initLineChart()
        }else{
          lineChart.dispose();
          this.getTableData()
        }
      },

      // 初始化流失表曲线图
      initLineChart() {
        console.log("this.tableData.totalNum",this.tableData.totalNum)
        let json2 = {
          pageNo: 1,
          pageSize: this.tableData.totalNum || 5
        };
        this.formInline.startTime = this.dataTime ? this.dataTime[0] : ''
        this.formInline.endTime = this.dataTime ? this.dataTime[1] : ''
        let json1 = this.formInline;
        let paramJson = { ...json1, ...json2 };
        console.log("初始化流失表曲线图paramJson",paramJson)

        this.axios({
          method:'get',
          url:'/novel/data/daily/chapterList',
          params:paramJson
        }).then((response)=>{
        if (response.data.head.flag === 0) {
            const list = response.data.content.result
            // 初始化 ECharts 实例
            lineChart = echarts.init(document.getElementById("lineChart"));
            // 在这里设置图表配置项和数据
            const option = {
              title: {
                text:""
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'cross',
                  label: {
                    backgroundColor: '#409effb5'
                  }
                },
                formatter: function (params) {
                  const userNumber = params[0].value;
                  const lossRate = list[params[0].dataIndex].churnRate; // 直接从 list 中获取流失率
                  const xAxisValue = params[0].name;
                  return `章节: ${xAxisValue}<br/>观看人数: ${userNumber}<br/>距上一集流失率: ${lossRate}`;
                }
              },
              legend: {
                data: ['观看人数']
              },
              xAxis: {
                type: 'category',
                name:'章节',
                boundaryGap: false,
                data: list.map(item => item.chapterNum)
              },
              yAxis: {
                name:'观看人数',
                type: 'value'
              },
              dataZoom: [
                {
                  type: 'slider',
                  show: true,
                  start: 0,
                  end: 100,
                  handleSize: 8
                },
                {
                  type: 'inside',
                  start: 0,
                  end: 100
                },
                {
                  type: 'slider',
                  show: true,
                  yAxisIndex: 0,
                  filterMode: 'empty',
                  width: 20,
                  height: '60%',
                  handleSize: 8,
                  showDataShadow: false,
                  left: '93%'
                }
              ],
              series: [{
                name: '观看人数',
                data: list.map(item => item.ipv),
                type: 'line',
                areaStyle: {}
              }]
            };
            // 使用 setOption 方法设置图表配置项和数据
            lineChart.setOption(option);
          } else {
            this.$message.error(response.data.head.desc)
          }
        })
 
      },
      
  }
}
</script>
<style lang="scss" scoped>
  .loss-title{
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    div{
      color: #409eff;
      cursor: pointer;
    }
  }
</style>
